import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import Fade from 'react-reveal/Fade'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import useStyles from './styles'
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri'

const settings = ({ arrowNext, arrowPrev, slickDots, arrowClass }) => {
  return {
    dots: true,
    dotsClass: slickDots,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow customClass={arrowNext} {...{ arrowClass }} />,
    prevArrow: <SamplePrevArrow customClass={arrowPrev} {...{ arrowClass }} />,
    fade: true,
    swipeToSlide: true,
    speed: 1000,
    autoplaySpeed: 4000,
  }
}

const CarouselPage = () => {
  const {
    arrowNext,
    arrowPrev,
    slickDots,
    arrowClass,
    slideWrapper,
    slideTitle,
    slideContent,
    slideSubtitle,
  } = useStyles()
  const { image1, image2, image3 } = useStaticQuery(getSliderImages)

  const slides = [
    {
      img: <Img fluid={image1.childImageSharp.fluid} />,
      title: 'Global Actuarial Services',
      subtitle: 'Más de 50 años de experiencia respaldan nuestros servicios',
    },
    {
      img: <Img fluid={image2.childImageSharp.fluid} />,
      title: 'Valuación de pasivos laborales',
      subtitle: 'La mejor solución en valuaciones actuariales',
    },
    {
      img: <Img fluid={image3.childImageSharp.fluid} />,
      title: 'Diseño de planes de beneficios',
      subtitle: 'Eleve su competitividad reteniendo al mejor talento',
    },
  ]

  return (
    <Slider
      {...settings({ arrowNext, arrowPrev, slickDots, arrowClass })}
      className="overflow-hidden"
    >
      {slides.map((e, i) => (
        <div key={i} className={slideWrapper}>
          <div>{e.img}</div>

          <Fade right>
            <div className={slideContent}>
              <div className={slideTitle}>
                <h3>{e.title}</h3>
              </div>
              <div className={slideSubtitle}>
                <h3>{e.subtitle}</h3>
              </div>
            </div>
          </Fade>
        </div>
      ))}
    </Slider>
  )
}

function SampleNextArrow(props) {
  const { customClass, onClick, arrowClass } = props
  return (
    <button
      id="next-arrow"
      className={customClass}
      onClick={onClick}
      onKeyDown={onClick}
    >
      <RiArrowRightSLine className={arrowClass} />
    </button>
  )
}

function SamplePrevArrow(props) {
  const { customClass, onClick, arrowClass } = props
  return (
    <button
      id="prev-arrow"
      className={customClass}
      onClick={onClick}
      onKeyDown={onClick}
    >
      <RiArrowLeftSLine className={arrowClass} />
    </button>
  )
}

const getSliderImages = graphql`
  query {
    image1: file(relativePath: { eq: "slide1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image2: file(relativePath: { eq: "slide2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image3: file(relativePath: { eq: "slide3.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default CarouselPage
